import * as APPCONFIG from "../config/app-config.js";

import auth from "./AuthAPI.js";
import Http from "./Http.js";
import api from "./BaseAPI.js";
class ServiceReferral {
  validateReferralCode(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/validateReferralCode`,
      data: formValues,
    });

  }



}
export default new ServiceReferral();